const DEFAULT_START_TIME = '0';

/**
 * Takes a string of form HH:MM:SS or MM:SS or SS and returns a number string. Returns '0' for
 * malformed strings.
 */
export const getStartTimeInSeconds = startTime => {
  if (!startTime) return DEFAULT_START_TIME;
  const startTimeArr = startTime.split(':')
  // If str is an empty string or number string, return NaN, else return the integer of the number.
  .map(str => Number.isNaN(Number(str)) || str === '' ? NaN : parseInt(str, 10));
  const isStartTimeMalformed = startTimeArr.some(e => Number.isNaN(e));
  if (isStartTimeMalformed || startTimeArr.length === 0 || startTimeArr.length > 3) return DEFAULT_START_TIME;

  // The length of startTimeArr is what tells us if we have seconds, minutes + seconds, or hours + minutes + seconds
  switch (startTimeArr.length) {
    // Just seconds
    case 1:
      {
        const startTimeSeconds = startTimeArr[0];
        return String(startTimeSeconds);
      }
    // Seconds + minutes
    case 2:
      {
        const startTimeMinutes = startTimeArr[0];
        const startTimeSeconds = startTimeArr[1];
        return String(startTimeMinutes * 60 + startTimeSeconds);
      }
    // Hours + minutes + seconds
    case 3:
      {
        const startTimeHours = startTimeArr[0];
        const startTimeMinutes = startTimeArr[1];
        const startTimeSeconds = startTimeArr[2];
        return String(startTimeHours * 60 * 60 + startTimeMinutes * 60 + startTimeSeconds);
      }
    default:
      return DEFAULT_START_TIME;
  }
};